import { RadioGroup } from "ui-kit/components-branded/index"
import { PaymentMethod } from "modules/ClientAccount/utils"

interface Props {
    onChange: () => void
    payByCard: PaymentMethod | null
}

export function CardItemAnother({ payByCard, onChange }: Props) {
    return (
        <RadioGroup.Item
            onChange={onChange}
            name="hide-profile-reason"
            className="is-fullwidth"
            value={undefined}
            checked={payByCard === null}
        >
            <div className="card-item-another">Другая карта</div>
        </RadioGroup.Item>
    )
}
